import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { bottomCta, LANDING_LINKS } from "./landingContent";

export default function LandingBottomCta() {
  const { t } = useTranslation();

  return (
    <section
      className="hr-landing-bottom-cta"
      aria-labelledby="hr-landing-bottom-cta-title"
    >
      <div className="home-page__container home-page__container--narrow hr-landing-bottom-cta__inner">
        <h2 id="hr-landing-bottom-cta-title" className="hr-landing-bottom-cta__title">
          {bottomCta.title}
        </h2>
        <p className="hr-landing-bottom-cta__text">{bottomCta.text}</p>
        <div className="hr-landing-bottom-cta__actions">
          <Link to={LANDING_LINKS.registerAgent} className="hr-landing-btn hr-landing-btn--on-dark">
            {t("navbar.joinasagent") || bottomCta.primary}
          </Link>
          <Link to={LANDING_LINKS.contact} className="hr-landing-btn hr-landing-btn--outline-light">
            {bottomCta.secondary}
          </Link>
        </div>
      </div>
    </section>
  );
}
